/**
 * Tooltip Component - Simple hover tooltip for help text
 */

import { useState } from 'react';
import './Tooltip.css';

const Tooltip = ({ children, content, position = 'top' }) => {
    const [isVisible, setIsVisible] = useState(false);

    if (!content) {
        return children;
    }

    return (
        <div
            className="tooltip-wrapper"
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            {children}
            <span className="tooltip-trigger">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
            </span>
            {isVisible && (
                <div className={`tooltip-content tooltip-${position}`}>
                    <div className="tooltip-arrow" />
                    {content}
                </div>
            )}
        </div>
    );
};

export default Tooltip;
